import { render, staticRenderFns } from "./PermalinksTable.vue?vue&type=template&id=722c7ae2&"
import script from "./PermalinksTable.vue?vue&type=script&lang=js&"
export * from "./PermalinksTable.vue?vue&type=script&lang=js&"
import style0 from "./PermalinksTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports